import PlusSvg from "../../assets/svg/plusSvg";
import SharedTable from "../../shared/sharedTable";
import CustomModal from "../../shared/CustomModal";
import { useEffect, useState } from "react";
import { generate } from "referral-codes";
import ExportApi from "../../api/ExportApi";
import { toast } from "react-toastify";
import { formatToLocalDate } from '../../helper/utils';

const Affiliates = () => {

    const columns = [
        {
            name: "Date",
            render: (row) => {
                return (
                    <div> {formatToLocalDate(row?.createdAt)}</div>
                )
            }
        },
        {
            name: "Affiliate Name",
            render: (row) => {
                return (
                    <div> {row?.name}</div>
                )
            }
        },
        {
            name: "Affiliate Code",
            render: (row) => {
                return (
                    <div> {row?.code}</div>
                )
            }
        }
    ]

    const [showAddModal, setShowAddModal] = useState(false);
    const [affiliate, setAffiliate] = useState({
        affiliateName: "",
        code: ""
    });
    const [affiliates, setAffiliates] = useState([]);
    const [loader, setLoader] = useState(false);

    const getAllAffiliate = () => {
        setLoader(true);
        ExportApi.getAffiliates()
            .then((resp) => {
                let data = resp.data;
                if (data?.success) {
                    setLoader(false)
                    setAffiliates(data?.data);
                }
                else {
                    setLoader(false)
                    setAffiliates([]);
                    toast.error(data?.message || "Error fetching affiliates");
                    setLoader(true)
                }
            })
            .catch((err) => {
                console.log(err);
                 setLoader(false);
                toast.error("Error fetching affiliates");
            });
    }

    useEffect(() => {
       getAllAffiliate();
    }, [])

    const [errors, setErrors] = useState({});

    const generateAffiliateCode = () => {
        const [code] = generate({
            length: 8,
            count: 1,
            charset: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
        });

        setAffiliate((prev) => ({
            ...prev,
            code: code
        }))

    };

    const validateAffiliate = (data) => {
        const newErrors = {};

        // Name validation
        if (!data.affiliateName?.trim()) {
            newErrors.affiliateName = "Affiliate name is required";
        } else if (!/^[A-Za-z\s]+$/.test(data.affiliateName)) {
            newErrors.affiliateName = "Only alphabets are allowed";
        } else if (data.affiliateName.trim().length <= 3) {
            newErrors.affiliateName = "Name must be more than 3 characters";
        }

        // Code validation
        if (!data.code?.trim()) {
            newErrors.code = "Affiliate code is required";
        } else if (data.code.length !== 8) {
            newErrors.code = "Affiliate code must be exactly 8 characters";
        }

        return newErrors;
    };

    const handleAddAffiliate = () => {
        const validationErrors = validateAffiliate(affiliate);
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length == 0) {
            ExportApi.addAffiliate({
                name: affiliate.affiliateName,
                code: affiliate.code
            })
                .then((resp) => {
                    let data = resp.data;
                    if (data?.success) {
                        setShowAddModal(false);
                        toast.success("Affiliate added successfully");
                        getAllAffiliate();
                    }
                    else {
                        toast.error(data?.message || "Error adding affiliate");
                        setShowAddModal(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    toast.error("Error adding affiliate");
                    setShowAddModal(false);

                });
        }
    }

    return (
        <div className="py-4">
            <div onClick={() => {
                generateAffiliateCode()
                setShowAddModal(true)
            }} style={{ cursor: "pointer" }} className="d-flex justify-content-end align-items-end pb-2">
                <PlusSvg height={30} width={30} />
            </div>
            <SharedTable loader={loader} columns={columns} data={affiliates} />

            <CustomModal
                show={showAddModal}
                handleClose={() => setShowAddModal(false)}
                headerText="Add Affiliate"
                actionButtonText="Add"
                closeButtonText="Close"
                actionButton={handleAddAffiliate}
            >
                <div>
                    <div className="mb-3 row align-items-center">
                        <label style={{fontSize : "18px" , fontWeight : 600}} className="col-sm-3 m-0 p-0">
                            Affiliate Name
                        </label>

                        <div className="col-sm-9 m-0 p-0">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter affiliate name"
                                value={affiliate?.name}
                                onChange={(e) => setAffiliate((prev) => ({
                                    ...prev,
                                    affiliateName: e.target.value
                                }))}
                            />

                            {
                                errors.affiliateName && (
                                    <div className="d-flex justify-content-start align-items-start pt-1">
                                        <span className="text-danger">{errors.affiliateName}</span>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className="mb-3 row align-items-center">
                        <label style={{fontSize : "18px" , fontWeight : 600}} className="col-sm-3 m-0 p-0">
                            Affiliate Code
                        </label>

                        <div className="col-sm-9 m-0 p-0">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter affiliate Code"
                                value={affiliate?.code}
                                onChange={(e) => setAffiliate((prev) => ({
                                    ...prev,
                                    code: e.target.value
                                }))}
                            />

                            {
                                errors.code && (
                                    <div className="d-flex justify-content-start align-items-start pt-1">
                                        <span className="text-danger">{errors.code}</span>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </CustomModal>
        </div>

    )
}

export default Affiliates;